import { render, staticRenderFns } from "./TableCustomerList.vue?vue&type=template&id=6caa4643&scoped=true"
import script from "./TableCustomerList.vue?vue&type=script&lang=js"
export * from "./TableCustomerList.vue?vue&type=script&lang=js"
import style0 from "./TableCustomerList.vue?vue&type=style&index=0&id=6caa4643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caa4643",
  null
  
)

export default component.exports